export default "__VITE_ASSET__CEtMSTNX__"